import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';
import { CHRONICLE_DISPLAY } from 'src/components/providers/theme';
import {
  EntityName,
  EventType,
  SectionName,
  TrkLocation,
} from 'src/utils/analytics/constants';
import { useImpressionEvent } from 'src/utils/analytics/hooks';
import { FlowCta } from '../flow-cta';
import { JumpPageSectionProps } from '../jump-page-body';

export const CtaSection: React.FC<JumpPageSectionProps> = ({
  analytics: { navigationId },
}) => {
  const theme = useTheme();

  const { ref } = useImpressionEvent({
    eventType: EventType.ElementImpression,
    navigationId,
    payload: {
      entity_name: EntityName.Flow,
      section_name: SectionName.JumpBottomCta,
      section_position: 6,
    },
  });
  return (
    <Box
      ref={ref}
      padding={5}
      sx={{ [theme.breakpoints.down('sm')]: { paddingY: 4, paddingX: 2 } }}
    >
      <Box
        paddingY={2}
        display="flex"
        flexDirection="column"
        alignContent="center"
        justifyContent="center"
        alignItems="center"
      >
        <Typography
          sx={{
            fontSize: 32,
            lineHeight: '111%',
            fontFamily: CHRONICLE_DISPLAY,
            fontWeight: 400,
            [theme.breakpoints.up('md')]: {
              fontSize: 54,
              lineHeight: '53px',
            },
          }}
          textAlign="center"
          marginBottom={2}
          component="h2"
        >
          Get personalized results in minutes
        </Typography>
        <Box width="13.5rem">
          <FlowCta trkLocation={TrkLocation.JumpPageBottom}>
            Get started
          </FlowCta>
        </Box>
      </Box>
    </Box>
  );
};
